// extracted by mini-css-extract-plugin
module.exports = {"project-admin-page":"styles_project-admin-page__hEgch","body":"styles_body__YqFrZ","content":"styles_content__kf0mO"};